export default "__VITE_ASSET__BOWcFjOI__"